import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Volume2, Loader2 } from 'lucide-react';
import { codexApi } from '../api';

/** Speaker button that fetches + plays the word's TTS pronunciation. */
export default function AudioButton({ wordId, label = 'Hear', size = 16 }) {
  const [loading, setLoading] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [error, setError] = useState(null);

  const play = async (e) => {
    e?.stopPropagation();
    if (loading) return;
    setError(null);
    try {
      let url = audioUrl;
      if (!url) {
        setLoading(true);
        url = await codexApi.fetchWordAudio(wordId);
        setAudioUrl(url);
      }
      const audio = new Audio(url);
      audio.play();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.button
      whileTap={{ scale: 0.92 }}
      onClick={play}
      disabled={loading}
      data-testid={`codex-audio-${wordId}`}
      title={error || 'Play pronunciation'}
      className="codex-btn codex-btn-ghost"
      style={{
        padding: '6px 10px',
        fontSize: 11,
        gap: 6,
        borderColor: error ? 'rgba(239,68,68,0.4)' : undefined,
        color: error ? '#f87171' : 'var(--codex-gold-light)',
      }}
    >
      {loading ? <Loader2 size={size} className="codex-shimmer" style={{ animation: 'spin 1.2s linear infinite' }} /> : <Volume2 size={size} />}
      <span>{label}</span>
    </motion.button>
  );
}
